export default {
      id: "refresh-rotated-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#refresh-rotated-usage",
      toString: function () {
        return this.url;
      }
    }